// src/components/AboutPage.jsx
import { usePageMeta } from "../utils/pageMeta";

export default function AboutPage({ onBack }) {
  usePageMeta({
    title: "펫말 소개 — 반려동물이 전하는 마음의 편지",
    description:
      "펫말은 반려동물의 마음을 편지로 전해드리는 서비스입니다. 펫말을 만든 이유와 편지가 전해지는 방식, 그리고 우리가 지키려는 약속을 소개합니다.",
    canonicalPath: "/about",
  });
  const section = { marginBottom: 28 };
  const h2 = {
    fontFamily: "'Jua', sans-serif",
    fontSize: 18,
    fontWeight: 700,
    color: "#5c3d2e",
    marginBottom: 10,
  };
  const p = {
    fontSize: 16,
    fontWeight: 400,
    color: "#6b5040",
    lineHeight: 2,
  };

  return (
    <div style={{ maxWidth: 600, margin: "0 auto", padding: "0 20px" }}>
      <button
        onClick={onBack}
        style={{
          display: "inline-flex", alignItems: "center", gap: 6,
          color: "#b09070", fontSize: 16, fontWeight: 400, cursor: "pointer",
          border: "none", background: "none",
          fontFamily: "'Gowun Batang', serif",
          padding: "8px 0", margin: "24px 0 20px",
        }}
      >
        ← 돌아가기
      </button>

      <div style={{
        background: "white",
        borderRadius: 24,
        padding: "36px 32px",
        boxShadow: "0 4px 24px rgba(92,61,46,0.07)",
        animation: "fadeUp .5s ease",
      }}>
        <div style={{ fontSize: 36, textAlign: "center", marginBottom: 16 }}>🐾</div>
        <div style={{
          fontFamily: "'Jua', sans-serif", fontSize: 24, fontWeight: 700,
          color: "#5c3d2e", marginBottom: 6, textAlign: "center",
        }}>
          펫말 소개
        </div>
        <div style={{ fontSize: 13, color: "#b09070", marginBottom: 28, textAlign: "center" }}>
          반려동물이 건네는 마음의 편지
        </div>

        <div style={section}>
          <div style={h2}>펫말이란?</div>
          <div style={p}>
            펫말은 반려동물의 마음을 편지로 전해드리는 따뜻한 공간입니다.
            말을 할 수 없었던 그 친구가 당신에게 꼭 하고 싶었던 이야기를,
            당신이 들려주신 추억을 바탕으로 한 통의 편지로 담아드려요.
            <br /><br />
            "말 못 하는 게 아니라, 말할 기회가 없었던 거예요."
            <br /><br />
            펫말은 이 한마디에서 시작됐습니다. 우리 곁을 지켜주던 동물 친구들이
            만약 말을 할 수 있었다면, 어떤 이야기를 해줬을까요? 함께한 시간 속
            그 마음을 AI가 대신 떠올리고, 진심이 담긴 편지로 전해드립니다.
          </div>
        </div>

        <div style={section}>
          <div style={h2}>어떻게 전해지나요?</div>
          <div style={p}>
            당신이 반려동물과의 추억, 성격, 함께한 에피소드를 들려주시면
            그 친구의 시점에서 마음을 담은 편지가 완성됩니다.
            강아지, 고양이, 햄스터, 토끼 등 어떤 동물 친구라도 괜찮아요.
            <br /><br />
            완성된 편지는 예쁜 편지지 위에 담겨,
            이미지로 간직하거나 소중한 분께 전할 수 있습니다.
          </div>
        </div>

        <div style={section}>
          <div style={h2}>이런 분들께 권해드려요</div>
          <div style={p}>
            - 반려동물과의 특별한 추억을 오래 간직하고 싶은 분<br />
            - 무지개다리를 건넌 아이에게 마지막 인사를 받고 싶은 분<br />
            - 말 없이 곁을 지켜주던 그 친구의 마음이 궁금한 분<br />
            - 특별한 날, 반려동물의 마음을 선물로 전하고 싶은 분<br />
            - 함께한 시간을 천천히 되돌아보고 싶은 분
          </div>
        </div>

        <div style={section}>
          <div style={h2}>펫말을 만든 이유</div>
          <div style={p}>
            펫말은 "떠난 친구의 입장이 되어 한 번이라도 편지를 받아본다면,
            남은 사람의 마음이 조금은 가벼워지지 않을까" 라는 작은 질문에서 시작됐습니다.
            <br /><br />
            가까운 사람이 오랜 시간 함께한 강아지를 보낸 뒤, 한참을 말이 없던
            모습을 본 날이 있었어요. 펫로스는 "동물인데 그렇게까지 슬퍼?"라는 한마디
            앞에서 쉽게 닫혀 버리는, 충분히 인정받지 못하는 슬픔입니다. 그 닫힌 마음을
            잠시 열어드리고 싶었습니다. 다정한 한 통의 편지로요.
          </div>
        </div>

        <div style={section}>
          <div style={h2}>펫말이 지키려는 약속</div>
          <div style={p}>
            펫말은 위로를 흉내내지 않습니다. "괜찮아질 거예요" 같은 빈 말을 만들지
            않으려 노력해요. 대신, 당신이 들려주신 그 친구의 성격·습관·작은 에피소드를
            그대로 가져와, 그 친구가 했을 법한 말투로 편지를 돌려드립니다. 그래서 펫말의
            편지는 모두 다릅니다.
            <br /><br />
            입력하신 추억과 편지 내용은 광고를 통해 무료로 서비스를 운영하기 위한
            범위에서만 활용되며, 동의 없이 외부에 공유되지 않습니다. 자세한 내용은
            개인정보처리방침에서 확인하실 수 있어요.
          </div>
        </div>

        <div style={section}>
          <div style={h2}>펫로스에 대한 더 많은 이야기</div>
          <div style={p}>
            반려동물과의 이별을 지나는 분들을 위해, 무지개다리의 의미부터 펫로스 증후군,
            추모와 회복까지 다룬 글들을 모아두었어요. 편지를 받기 전후로 천천히
            읽어보셔도 좋습니다.
          </div>
        </div>

        <div style={section}>
          <div style={h2}>운영 및 문의</div>
          <div style={p}>
            펫말은 엔돌핀스튜디오에서 만들고 운영하고 있습니다.<br />
            서비스 이용 중 궁금한 점이나 의견이 있으시면 언제든
            <strong> rnak24@gmail.com </strong>으로 연락해주세요.
            보내주신 한 분 한 분의 이야기를 소중히 듣고 있습니다.
          </div>
          <div style={{ ...p, fontSize: 13, color: "#b09070", marginTop: 10 }}>
            상호: 엔돌핀스튜디오 | 대표: 이유석 | 사업자등록번호: 775-14-02749
          </div>
        </div>
      </div>

      <div style={{ textAlign: "center", marginTop: 24, marginBottom: 24 }}>
        <button
          onClick={onBack}
          style={{
            padding: "16px 48px", borderRadius: 16,
            background: "linear-gradient(135deg, #c4845a, #d4a070)",
            color: "white", fontSize: 16, fontWeight: 700, fontFamily: "'Jua', sans-serif",
            border: "none", cursor: "pointer",
            boxShadow: "0 4px 18px rgba(196,132,90,.35)",
          }}
        >
          편지 받으러 가기
        </button>
      </div>
    </div>
  );
}
